import React, { useState } from 'react';
import styled from '@emotion/styled';
import { SearchIcon, XIconDark } from '../../components/icons';

const InputStyles = styled.div`
  background-color: #f5f5f5;
  /* border-bottom: 1px solid #444340; */
  display: flex;
  margin-bottom: 23px;
  position: relative;
  border-radius: 5px;
  input:focus {
    border: none !important;
    outline: none !important;
  }
  svg {
    margin: 18px 10px 0 16px;
    @media (min-width: 768px) {
      margin: 24px 18px 0 28px;
    }
  }
`;
const CustomInput = styled.input`
  width: 100%;
  background-color: #f5f5f5;
  border-radius: 1px;
  border: none;
  border-radius: 5px;
  height: 60px;
  font-family: IBM Plex Sans;
  @media (min-width: 768px) {
    height: 72px;
  }
`;

interface Props {
  search: (searchText: string) => void;
  searchText: string;
  onSearchTextChange: (searchText: string) => void;
  closeSearch: () => void;
}
const Search = (props: Props) => {
  const [searchOpen, setSearchOpen] = useState(false);
  return (
    <div>
      <InputStyles>
        <SearchIcon />
        <CustomInput
          placeholder='Search for an order'
          onKeyPress={(e) => {
            setSearchOpen(true);
          }}
          value={props.searchText}
          onFocus={() => {
          }}
          onChange={(e: any) => {
            props.onSearchTextChange(e.target.value);
          }}
        />
        {(searchOpen || props.searchText) && (
          <XIconDark
            onClick={() => (setSearchOpen(false), props.closeSearch())}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              right: 16,
            }}
          />
        )}
      </InputStyles>
    </div>
  );
};

export default Search;
